import Chart from "chart.js";
import { Line } from "vue-chartjs";
import Component from "vue-class-component";
import { Mixins, Prop } from "vue-property-decorator";

export interface ChartInfo {
  serial: string;
  lastIp: string;
  connectedPoints: Chart.ChartPoint[];
  disconnectedPoints: Chart.ChartPoint[];
}

Chart.Tooltip.positioners.mouse = (elements, eventPosition) => {
  console.log("tooltip event", eventPosition);
  return eventPosition;
}

@Component({
  extends: Line, // This is needed to add the Line graphs functionality to the component
})
export default class ConnectionHistoryChart extends Mixins(Line) {
  @Prop() readonly data!: ChartInfo;
  @Prop() readonly from!: Date;
  @Prop() readonly to!: Date;

  options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    scales: {
      xAxes: [
        {
          type: "time",
          position: "bottom",
          time: {
            unit: "hour"
          },
          ticks: {
            major: {
              enabled: true,
              fontStyle: "bold",
              fontSize: 14
            },
            maxRotation: 0,
            min: this.from,
            max: this.to
          }
        }
      ],
      yAxes: [
        {
          display: false,
          ticks: {
            // Use +/- 0.1 to allow the line to show in the min and max positions
            max: 1.1,
            min: -0.1
          }
        }
      ]
    }
  }

  mounted() {
    this.renderChart({
      datasets: [
        {
          backgroundColor: "transparent",
          borderColor: "green",
          borderCapStyle: "square",
          data: this.data.connectedPoints,
          pointRadius: 0, // Hide the points
          steppedLine: "before"
        },
        {
          backgroundColor: "transparent",
          borderColor: "red",
          data: this.data.disconnectedPoints,
          pointRadius: 0, // Hide the points
          steppedLine: "before"
        },
      ]
    }, this.options);
  }
}
